import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ViewChild,
  HostListener,
} from '@angular/core';
import { MatSidenavContent } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { distinctUntilChanged, filter, map, tap } from 'rxjs';

import { AppFacade } from '@shared/state/facades';
import { NotificationService, ScreenSizeService } from '@shared/services';

@UntilDestroy()
@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainLayoutComponent implements OnInit {
  @ViewChild(MatSidenavContent, { static: true })
  matSidenavContent: MatSidenavContent;

  isSidebarOpen: boolean;
  screenWidth: number;
  isFullScreenMode$ = this.appFacade.query.isFullScreenMode$;
  isLoading$ = this.appFacade.query.isLoading$;

  constructor(
    private appFacade: AppFacade,
    private notificationService: NotificationService,
    private router: Router,
    protected screenSizeService: ScreenSizeService
  ) {
    this.appFacade.query.sidebarStatus$
      .pipe(
        untilDestroyed(this),
        tap((sidebarStatus) => (this.isSidebarOpen = sidebarStatus))
      )
      .subscribe();

    // scroll back to top of page on route change
    this.router.events
      .pipe(
        untilDestroyed(this),
        filter(
          (r) =>
            r instanceof NavigationEnd &&
            !!this.matSidenavContent?.getElementRef()?.nativeElement
        ),
        // this is needed to avoid scrolling up on modal routing
        //  in this case only query parameters change
        map((r) => (r as NavigationEnd).url.split('?')[0]),
        distinctUntilChanged(),
        tap(() => {
          this.matSidenavContent.getElementRef().nativeElement.scrollTop = 0;
        })
      )
      .subscribe();
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.screenWidth = window.innerWidth;
  }

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.notificationService.setup();
  }

  toggleFullScreenMode(): void {
    this.appFacade.toggleFullScreenMode();
  }

  toggleSidebar(): void {
    this.appFacade.toggleSidebar();
  }
}
